import * as S from "./WeekExcerciseList.style";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { Loading } from "@/components/atoms/Loading";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { ExerciseRecomBox } from "../ExerciseRecomBox";
import { ExerciseCategory } from "@/common/types/video";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow_rt_color.svg";

interface WeekExcerciseListProps {
  studentId?: string;
  weekExerciseCategories: ExerciseCategory[];
  exercisePointEligibility?: any;
}

export const WeekExcerciseList = ({
  studentId,
  weekExerciseCategories,
  exercisePointEligibility,
}: WeekExcerciseListProps) => {
  const navigate = useNavigate();
  const [exerciseModalShow, setExerciseModalShow] = useState(false);

  const { data: weekExerciseSummary, isPending } = useQuery({
    queryKey: ["week-exercise-categories"],
    queryFn: () =>
      request<any>({
        method: "GET",
        url: `/exercise/week-list/${studentId}`,
      }),
  });

  const handleExerciseConfirm = (result: boolean) => {
    if (result) {
      navigate(`/exercise/set/1`);
    } else {
    }
  };

  return (
    <>
      {isPending ? (
        <Loading />
      ) : (
        <S.WeekExerciseListBox>
          <S.WeekExerciseListTit>
            신체 건강 운동 프로그램
            <Buttons
              type="button"
              size="more"
              layout="text"
              color="primary100"
              label="전체 보기"
              // onClick={() => navigate(`/exercise/set/1`)}
              onClick={() => {
                // if (
                //   Number(exercisePointEligibility?.exerciseCount) === 36 ||
                //   exercisePointEligibility?.points === 50000
                // ) {
                //   setExerciseModalShow(true);
                // } else {
                //   navigate(`/exercise/set/1`);
                // }
                navigate(`/exercise/set/1`);
              }}
            >
              <IconArrow width={22} height={22} />
            </Buttons>
          </S.WeekExerciseListTit>
          <S.WeekExerciseList>
            {weekExerciseCategories.map(
              (weekExerciseCategories: ExerciseCategory, idx: number) => {
                return (
                  <ExerciseRecomBox
                    key={idx}
                    type="exercise"
                    title={weekExerciseSummary.todayVideoContent[idx].title}
                    thumbnailUrl={
                      weekExerciseSummary.todayVideoContent[idx].thumbnailUrl
                    }
                    duration={
                      weekExerciseSummary.todayVideoContent[idx].duration
                    }
                    onClick={() => navigate(weekExerciseCategories.path)}
                  />
                );
              }
            )}
          </S.WeekExerciseList>
        </S.WeekExerciseListBox>
      )}
      {/* {exerciseModalShow &&
        (exercisePointEligibility &&
        exercisePointEligibility?.points === 50000 &&
        Number(exercisePointEligibility?.exerciseCount) === 36 ? (
          <ModalExerciseConfirm
            setModalShow={setExerciseModalShow}
            onConfirm={handleExerciseConfirm}
            type="all"
          />
        ) : exercisePointEligibility?.points === 50000 ? (
          <ModalExerciseConfirm
            setModalShow={setExerciseModalShow}
            onConfirm={handleExerciseConfirm}
            type="point"
          />
        ) : (
          <ModalExerciseConfirm
            setModalShow={setExerciseModalShow}
            onConfirm={handleExerciseConfirm}
            type="exercise"
          />
        ))} */}
    </>
  );
};
